var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFlight = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2767_561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 16V14L13 9V3.5C13 2.67 12.33 2 11.5 2C10.67 2 10 2.67 10 3.5V9L2 14V16L10 13.5V19L8 20.5V22L11.5 21L15 22V20.5L13 19V13.5L21 16Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2767_561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flight.5b0ab87b.svg";
export { ForwardRef as ReactComponent };